/**
 * Create Duel HTTP Service
 * 
 * Calls the create-duel endpoint to initiate a new duel.
 */

import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { CreateDuelInput, CreateDuelOutput, WebAppRoutes } from "types/web-app";

/**
 * Create a new duel between the authenticated player and an opponent
 */
export const createDuel = async (
  accessToken: string,
  input: CreateDuelInput,
): Promise<ServiceResponse<CreateDuelOutput>> => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.CREATE_DUEL,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<CreateDuelOutput>;
  } catch (error) {
    console.error("Error creating duel:", error);
    throw error;
  }
};

